import React from "react";
import { Icon } from "@iconify/react";

function ContactIcon() {
  return (
    <div>
      <Icon
        icon="fluent:phone-laptop-24-regular"
        color="#707070"
        width="64"
        height="59"
      />
    </div>
  );
}

export default ContactIcon;
